import React from "react";
import classNames from "classnames";
import { DoctorHighlightParams } from "./DoctorHighlightParams.csharp";

interface DoctorHighlightWithLargerImagesParams extends DoctorHighlightParams {
  enableLargerImages: boolean;
  showAlternateColors: boolean;
}

export const DoctorHighlight: React.FC<
  DoctorHighlightWithLargerImagesParams
> = ({
  imageUrl,
  heading,
  subheading,
  content,
  link,
  enableLargerImages,
  showAlternateColors,
}) => {
  return (
    <div
      className={classNames(
        "card theme-inherit-light",
        { "card-hover": link },
        { "show-alternate-colors": showAlternateColors }
      )}
    >
      <div className="card-body d-block">
        <img
          className={
            !enableLargerImages
              ? "circular-image medium mb-3"
              : "rounded-image mb-md-3"
          }
          src={
            imageUrl +
            (!enableLargerImages
              ? "?width=216&height=216&rmode=crop&ranchor=top"
              : "?width=220&height=250&rmode=crop&ranchor=top")
          }
          alt={heading}
        />
        <div>
          <h3 className="h5">
            {link ? (
              <a className="card-block-link" href={link}>
                {heading}
              </a>
            ) : (
              <span>{heading}</span>
            )}
          </h3>
          <p className="fw-bold">{subheading}</p>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  );
};
